import './addBusiness.scss';
import React, {useState} from "react";
import {AddBusinessType} from 'models';
import {ReactComponent as EXIT_ICON} from 'assets/icons/exit_icon.svg'
import {
    AddBusinessStart,
    InformationSection,
    DetailsSection,
    CategorySection,
    CongratsSection,
    ProductsAndServices,
    RequiredAssistance,
    Expectations,
    OtherInformation,
    Payment
} from './sections';
import useAddBusiness from "../../../../operations/mutations/useAddBusiness";
import {useSession} from "../../../../providers/UseSession";


interface AddBusinessProps {
    closeModal: () => void
}

const AddBusiness: React.FC<AddBusinessProps> = ({closeModal}) => {
        const {payload} = useSession();

        const [newBusinessInfo, setNewBusinessInfo] = useState<AddBusinessType>({
            member_id: payload.id,
            is_approved: false,
            membership_level: "",
            date_approved: "",
            information: {
                title: "",
                name: "",
                address: "",
                contact: "",
                email: "",
                website: "",
            },
            details: {
                is_registered: "",
                registration_number: "",
                tax_registration_number: "",
                is_new: "",
                business_type: "",
            },
            category: {
                service_type: "",
                category: "",
                years: 1,
                target_market: "",
                number_of_employees: "",
            },

            products_services: [{type: "", name: "", description: ""}],

            required_assistance: {
                assistance: [],
                expos_assistance: ""
            },
            expectation_of_sbaj: "",
            other_information: {
                committee_service: "",
                how_did_you_find_us: "",
                list_in_directory: "",
                other_employment: "",
                specify: "",
                area_of_expertise: ""
            },
            payment: ""
        })
        const {mutateAsync} = useAddBusiness();
        const stepsCount = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        const [step, setStep] = useState<number>(0);
        const [sectionName, setSectionName] = useState('')

        const changeStep = (direction: string) => {
            if (direction === 'next')
                setStep(prevStep => (prevStep < stepsCount.length ? (prevStep + 1) : prevStep))

            if (direction === 'prev')
                setStep(prevStep => (prevStep > 0 ? (prevStep - 1) : prevStep))
        }

        const submitForm = async () => {

            try {
                await mutateAsync({
                    member_id: newBusinessInfo.member_id,
                    is_approved: false,
                    date_approved: "",
                    membership_level: newBusinessInfo?.membership_level,
                    information: {
                        ...newBusinessInfo?.information,
                        website: "https://" + newBusinessInfo?.information.website.replace('https://', '')
                    },
                    details: newBusinessInfo?.details,
                    category: newBusinessInfo?.category,
                    products_services: newBusinessInfo?.products_services,
                    required_assistance: newBusinessInfo?.required_assistance,
                    expectation_of_sbaj: newBusinessInfo?.expectation_of_sbaj,
                    other_information: newBusinessInfo?.other_information,
                    payment: newBusinessInfo?.payment
                })
                changeStep("next")
            } catch (err) {
                console.log(err)
            }
            // setBusinessData((prev: BusinessPanel[]) => [...prev, {id: prev.length + 1, business: newBusinessInfo}])
        }


        const loadForm = () => {
            switch (step) {
                case 0:
                    return <AddBusinessStart changeStep={changeStep}/>
                case 1: {

                    return <InformationSection
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        setSectionName={setSectionName}
                    />
                }
                case 2:
                    return <DetailsSection
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        setSectionName={setSectionName}
                    />
                case 3:
                    return <CategorySection
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        setSectionName={setSectionName}
                    />

                case 4:
                    return <ProductsAndServices
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        setSectionName={setSectionName}
                    />
                case 5:
                    return <RequiredAssistance
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        setSectionName={setSectionName}
                    />

                case 6:
                    return <Expectations
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        setSectionName={setSectionName}
                    />

                case 7:
                    return <OtherInformation
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        setSectionName={setSectionName}
                    />

                case 8:
                    return <Payment
                        changeStep={changeStep}
                        newBusinessInfo={newBusinessInfo}
                        setNewBusinessInfo={setNewBusinessInfo}
                        submitForm={submitForm}
                        setSectionName={setSectionName}
                    />

                case 9:
                    return <CongratsSection
                        closeModal={closeModal}
                    />
                default:
                    break;
            }
        }


        return (
            <div className={'modal_wrapper'}>
                <div className={'add-business '}>
                    <EXIT_ICON className={'exit_icon'} onClick={closeModal}/>
                    <div className={'add-business_top'}>
                        {/*{(step !== (0 || 5)) && <div className={'add-business_top_stepper'}>*/}
                        {/*    {stepsCount.map((steps, index) => (*/}
                        {/*        <div key={steps + index}*/}
                        {/*             onClick={() => steps !== 0 ? setStep(index + 1) : null}*/}
                        {/*             className={['add-business_top_stepper_step',*/}
                        {/*                 step >= steps ? "done" : null,*/}
                        {/*                 step >= steps ? "cursor" : null,*/}
                        {/*                 step === steps ? "active" : null,*/}
                        {/*             ].join(' ')}>*/}
                        {/*            {steps}*/}
                        {/*        </div>*/}
                        {/*    ))}*/}
                        {/*</div>}*/}
                        {(step !== 0) &&
                        <div className={'add-business_top_heading'}>
                            <h1>{sectionName}</h1>
                            <span>Step <span>{step}</span>/{stepsCount.length - 1}</span>
                        </div>}
                    </div>
                    <div className={'add-business_bottom '}>
                        {loadForm()}
                    </div>
                </div>
            </div>
        );
    }
;

export default AddBusiness;



